import { createContext, useContext } from 'react'
import german from './de-DE'
import english from './en-GB'

export type Strings = typeof german
export const Strings = (language: string): Strings => {
  if (language.startsWith('en')) return english as unknown as Strings
  return german
}

// Create a default value to prevent undefined errors
const defaultLanguage = 'en'
const defaultStrings = Strings(defaultLanguage)
const defaultContext = {
  strings: defaultStrings,
  language: defaultLanguage,
  setLanguage: (_: string) => console.warn('StringsContext not initialized')
}

export const StringsContext = createContext<{ strings: Strings; language: string; setLanguage(_: string): void }>(defaultContext)

export const useStrings: {
  <T extends string>(prefix: T): { [K in Extract<keyof Strings, `${T}${string}`> as K extends `${T}${infer R}` ? Uncapitalize<R> : never]: Strings[K] }
  (): Strings
} = (prefix?: string): any => {
  const { strings } = useContext(StringsContext)
  if (prefix)
    return Object.fromEntries(
      Object.keys(strings)
        .filter(k => k.startsWith(prefix))
        .map(k => [k[prefix.length].toLowerCase() + k.slice(prefix.length + 1), strings[k]])
    )
  return strings
}
